<template>
  <div />
</template>

<script>
export default {
  name: "approvalPassRouter",
  data() {
    return {
      editable: true,
      sysApprovalRequestId: "",
    };
  },
  watch: {},
  created() {},
  beforeMount() {
    this.init();
  },
  destroyed() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      if (this.$route.query.sysApprovalRequestId) {
        this.sysApprovalRequestId = this.$route.query.sysApprovalRequestId;
        setTimeout(() => {
          this.$router.push(
            "/sys/appr/doc/apprPass?sysApprovalRequestId=" +
              this.sysApprovalRequestId,
          );
        }, 1000);
      } else {
        window.getApp.$emit("ALERT", {
          title: "안내",
          message: "회람 대상자가 아닙니다.",
          type: "warning", // success / info / warning / error
        });
      }
      // list setting
    },
  },
};
</script>
